import { configureStore } from "@reduxjs/toolkit";
import UserStateSlice from "./UserStateSlice";
import AppUISlice from "./AppUISlice";
import ProjectSlice from "./Project/ProjectSlice";


const store = configureStore({
  reducer: {
    appUI: AppUISlice,
    userState: UserStateSlice,
    project: ProjectSlice
  },
  devTools: !process.env.NODE_ENV || process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export default store;
